import React from 'react'
import CKEditor from "ckeditor4-react-advanced"

const VisaPackageForm = (props) => {
    return (
        <form>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Name</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="name" value={props.name} onChange={props.onChange} />
                        <span className="error">{props.errors.name}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Category</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="category" value={props.category} onChange={props.onChange} />
                        <span className="error">{props.errors.category}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Price</label>
                    </div>
                    <div className="form-input">
                        <input type="number" name="price" value={props.price} onChange={props.onChange} />
                        <span className="error">{props.errors.price}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Features</label>
                    </div>
                    <div className="form-input">
                        <textarea name="features" value={props.features} onChange={props.onChange} rows={5} placeholder="One feature per line" />
                        <span className="error">{props.errors.features}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Featured</label>
                    </div>
                    <div className="form-input">
                        <select
                            name="featured"
                            value={props.featured}
                            onChange={(e) => props.onChange({ target: { name: 'featured', value: Number(e.target.value) } })}
                        >
                            <option value={0}>No</option>
                            <option value={1}>Yes</option>
                        </select>
                        <span className="error">{props.errors.featured}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Status</label>
                    </div>
                    <div className="form-input">
                        <select
                            name="status"
                            value={props.status}
                            onChange={(e) => props.onChange({ target: { name: 'status', value: Number(e.target.value) } })}
                        >
                            <option value={0}>Draft</option>
                            <option value={1}>Published</option>
                            <option value={2}>Archived</option>
                        </select>
                        <span className="error">{props.errors.status}</span>
                    </div>
                </div>
                <div className="row editor">
                    <div className="form-label">
                        <label>Description</label>
                    </div>
                    <CKEditor key={props.keyDescription}
                        data={props.description}
                        config={{
                            width: "100%",
                            versionCheck: false
                        }}
                        onChange={(event) => {
                            const data = event.editor.getData()
                            props.onChange({
                                target: {
                                    name: "description",
                                    value: data
                                }
                            })
                        }}
                    />
                    <span className="error">{props.errors.description}</span>
                </div>
            </div>
            <div className="actions">
                <button type="submit" onClick={props.onSubmit}>{props.action}</button>
                <button type="reset" onClick={props.onCancel}>Cancel</button>
            </div>
        </form>
    )
}

export default VisaPackageForm
